import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { P404Component } from './modules/shared/error/p404/p404.component';
import { HomeLayoutComponent } from './modules/layout/home-layout/home-layout.component';
import { DashboardLayoutComponent } from './modules/layout/dashboard-layout/dashboard-layout.component';
import { HOME_LAYOUT_ROUTES } from './modules/routes/home-layout-routes';
import { DASHBOARD_LAYOUT_ROUTES } from './modules/routes/dashbaord-layout-routes';
import { AUTH_LAYOUT_ROUTES } from './modules/routes/auth-layout-routes';
import { AuthLayoutComponent } from './modules/layout/auth-layout/auth-layout.component';

const routes: Routes = [
  { path: '', component: HomeLayoutComponent, children: HOME_LAYOUT_ROUTES },
  { path: 'backend', component: DashboardLayoutComponent, children: DASHBOARD_LAYOUT_ROUTES },
  { path: 'auth', component: AuthLayoutComponent, children: AUTH_LAYOUT_ROUTES },
  { path: '**', component: P404Component }
];


@NgModule({
  imports: [

    RouterModule.forRoot(routes, {
      useHash: true
    })

  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
